import { ReactNode } from 'react'
import { Spacer, Text } from '@vinted/web-ui'

import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'

import ResponsiveWrapper from '../../ReponsiveWrapper'

type Props = {
  title: string
  description?: string
  children: Array<ReactNode>
  html?: boolean
}

const FactsSection = ({ title, description, children, html }: Props) => (
  <section>
    <Text as="h3">
      <div className="safety_facts-block-title">{title}</div>
    </Text>
    {!!description && (
      <>
        <ResponsiveWrapper mobile={<Spacer />} desktop={<Spacer size="large" />} />
        <Text as="span" html={html}>
          <div className="safety_body">{description}</div>
        </Text>
      </>
    )}
    <ResponsiveWrapper mobile={<Spacer size="x-large" />} desktop={<Spacer size="x2-large" />} />
    <div className="page-section__facts">
      <SeparatedList
        separator={
          <ResponsiveWrapper
            mobile={<Spacer size="large" />}
            desktop={<Spacer size="x4-large" orientation="vertical" />}
          />
        }
      >
        {children}
      </SeparatedList>
    </div>
    <ResponsiveWrapper mobile={<Spacer size="x2-large" />} desktop={<Spacer size="x4-large" />} />
  </section>
)

export default FactsSection
